var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriorityFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.525 1.074a.315.315 0 0 0-.465 0L1.013 5.066c-.137.137-.137.356 0 .465l.547.547a.315.315 0 0 0 .465 0l3.281-3.226L8.56 6.078c.137.137.356.137.465 0l.547-.547c.137-.11.137-.328 0-.465L5.525 1.074zM5.06 5.45 1.013 9.441c-.137.137-.137.356 0 .465l.547.547a.315.315 0 0 0 .465 0l3.281-3.226 3.254 3.226c.137.137.356.137.465 0l.547-.547c.137-.11.137-.328 0-.465L5.525 5.45a.315.315 0 0 0-.465 0z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityFilter);
export default __webpack_public_path__ + "static/media/priority-filter.bb5b2954aa0a3c2f65a1ed42007bcf70.svg";
export { ForwardRef as ReactComponent };